// // src/components/allblogs/AllBlogs.js

import React, { useState, useEffect } from "react";
import axios from "../../axiosConfig"; // Import configured Axios instance
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Container,
  Button,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";

// ✅ Styled Components Instead of makeStyles
const Root = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

const StyledCard = styled(Card)({
  border: "1px solid #cbcaca",
  backgroundColor: "#f5f5f5",
  height: "100%",
  display: "flex",
  borderRadius: "8px",
  flexDirection: "column",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.5s",
  "&:hover": {
    transform: "scale(1.05)",
  },
});

const CardImage = styled("img")(({ theme }) => ({
  height: 200,
  width: "auto",
  marginBottom: theme.spacing(2),
  borderRadius: "4px 4px 0 0",
  padding: "5px"
}));

const Message = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  marginTop: theme.spacing(4),
}));

const BlogsList = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("jwtToken")
  );

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("/api/all-blogs");
        setBlogs((response.data.blogs || []).filter((blog) => blog.status === 'published'));
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setIsAuthenticated(false);
        } else {
          console.error("Error fetching all blogs:", error);
        }
      }
    };

    if (isAuthenticated) {
      fetchBlogs();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <Root>
        <Message variant="h4" gutterBottom>
          You must be logged in to view all blogs.
        </Message>
        <div style={{ textAlign: "center", marginTop: "16px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/login")}
          >
            Log In
          </Button>
        </div>
      </Root>
    );
  }

  return (
    <Root>
      <Typography variant="h4" gutterBottom>
        All Blogs
      </Typography>
      <Grid container spacing={3}>
        {blogs.map((blog) => (
          <Grid item xs={12} sm={6} md={4} key={blog._id}>
            <Link
              to={`/blog/${blog._id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <StyledCard>
                <CardImage src={blog.imageUrl} alt={blog.title} />
                <CardContent>
                  <Typography variant="h5" component="h2">
                    {blog.title}
                  </Typography>
                  <Typography color="textSecondary" gutterBottom>
                    Author: {blog.author.name}
                  </Typography>
                  <Typography variant="body2" component="p" dangerouslySetInnerHTML={{ __html: blog.content.substring(0, 100) + '...' }}>
                  </Typography>
                </CardContent>
              </StyledCard>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Root>
  );
};

export default BlogsList;
